import React from "react";
import CampaignRcsForm from "../../../components/campaigns/rcs/CampaignRcsForm";

const NewCampaignRcs = () => {
  return (
    <>
      <div className="text-3xl py-2 font-bold text-gray-600">
        Nueva Campaña RCS
      </div>
      <CampaignRcsForm />
    </>
  );
};

export default NewCampaignRcs;
